/* Dogs Supreme — Sticky Cart Bar v23 (2026-05-11)
 * Floating Glass-Card Show/Hide + Cart-Add + Variant-Sync.
 * Tracking via fetch /cart/add.js → ds-cart-tracking.js Interceptor (kein Doppel-Tracking).
 * Show/Hide via IntersectionObserver auf [data-add-to-cart] Sentinel mit Hysterese.
 */

(function() {
  'use strict';

  var bar = document.getElementById('DsCartBar');
  var btn = document.getElementById('DsCartBarBtn');
  var priceEl = document.getElementById('DsCartBarPrice');
  var textEl = document.getElementById('DsCartBarText');
  if (!bar || !btn || !textEl) return;

  var DEBUG = /[?&]ds_debug=1/.test(location.search);
  var sectionId = btn.getAttribute('data-section-id');
  var currentVariantId = parseInt(btn.getAttribute('data-variant-id'), 10);
  var labelAdd = btn.getAttribute('data-label-add') || 'In den Warenkorb';
  var labelSoldout = btn.getAttribute('data-label-soldout') || 'Ausverkauft';
  var labelAdding = btn.getAttribute('data-label-adding') || 'Wird hinzugefuegt…';
  var labelAdded = btn.getAttribute('data-label-added') || 'Hinzugefuegt ✓';

  function log() {
    if (!DEBUG) return;
    var args = ['[DS-CartBar]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  /* ─── Money-Formatter (umgeht theme.Currency.formatMoney HTML-Bug) ─── */
  function dsFormatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ─── Show / Hide ─── */
  var hideTimer = null;
  var HIDE_DELAY = 300;

  function show() {
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    bar.setAttribute('data-state', 'visible');
    bar.setAttribute('aria-hidden', 'false');
    document.body.setAttribute('data-has-cart-bar', 'visible');
    log('show');
  }

  function hide() {
    bar.setAttribute('data-state', 'hidden');
    bar.setAttribute('aria-hidden', 'true');
    document.body.removeAttribute('data-has-cart-bar');
    log('hide');
  }

  /* ─── Show/Hide-Mechanik: IntersectionObserver direkt auf Haupt-ATC + Scroll-Fallback ─── */
  // Beobachtet den HAUPT-ATC-Button DIREKT (statt unsichtbarem Sentinel). Robuster auf allen
  // Mobile-Browsers, da der Button immer im DOM ist und IO zuverlaessig funktioniert.
  var mainAtcBtn = document.querySelector('[data-add-to-cart]');
  if (mainAtcBtn && 'IntersectionObserver' in window) {
    // rootMargin in Pixel statt %: stabil ueber Viewport-Aenderungen (Toolbar-Collapse).
    // Multiple thresholds: Bar erscheint fluessig statt schlagartig.
    new IntersectionObserver(function(entries) {
      var entry = entries[0];
      var visible = entry.isIntersecting;
      log('mainAtc intersect visible=' + visible + ' ratio=' + entry.intersectionRatio.toFixed(2));
      if (!visible) {
        // Haupt-ATC raus aus View → Bar sofort zeigen
        show();
      } else if (entry.intersectionRatio > 0.3) {
        // Haupt-ATC >30% in View → Bar mit Hysterese verstecken
        if (!hideTimer) {
          hideTimer = setTimeout(function() { hide(); hideTimer = null; }, HIDE_DELAY);
        }
      } else {
        // Haupt-ATC nur teilweise in View (<30%) — Bar bleibt sichtbar, kein Toggle
      }
    }, {
      // Mehrere Thresholds fuer fluessigere Detection
      threshold: [0, 0.3, 0.5, 1],
      // Negativer rootMargin: Bar erscheint frueher, verschwindet spaeter (besseres Mobile-Feel)
      rootMargin: '-10% 0px -20% 0px'
    }).observe(mainAtcBtn);

    // Scroll-Backup-Listener: falls IO buggy ist (alte iOS-Safari), check via getBoundingClientRect.
    // Throttled @ rAF fuer Performance.
    var scrollCheckTicking = false;
    function scrollCheck() {
      if (scrollCheckTicking) return;
      scrollCheckTicking = true;
      requestAnimationFrame(function() {
        var rect = mainAtcBtn.getBoundingClientRect();
        var vh = window.innerHeight;
        // Haupt-ATC vollstaendig oberhalb des Viewports (bottom < 0)
        // oder unterhalb (top > vh): nicht sichtbar
        var visible = rect.bottom > 0 && rect.top < vh * 0.8;
        if (!visible && bar.getAttribute('data-state') === 'hidden') {
          // IO hat versagt — wir zeigen Bar manuell
          show();
        }
        scrollCheckTicking = false;
      });
    }
    window.addEventListener('scroll', scrollCheck, { passive: true });
  } else if (mainAtcBtn) {
    // No IntersectionObserver-Support: Scroll-Listener-only
    var lastVisible = true;
    window.addEventListener('scroll', function() {
      var rect = mainAtcBtn.getBoundingClientRect();
      var visible = rect.bottom > 0 && rect.top < window.innerHeight;
      if (visible === lastVisible) return;
      lastVisible = visible;
      if (!visible) show();
      else if (!hideTimer) hideTimer = setTimeout(function() { hide(); hideTimer = null; }, HIDE_DELAY);
    }, { passive: true });
  } else {
    // Kein Sentinel: Bar nach 1500ms permanent zeigen
    setTimeout(show, 1500);
  }

  /* ─── Add-to-Cart Click ─── */
  var isAdding = false;
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    if (btn.disabled || isAdding) return;
    isAdding = true;
    btn.disabled = true;
    var origText = textEl.textContent;
    textEl.textContent = labelAdding;

    var _dsPackQ = document.querySelector('[data-ds-form-qty]');
    var _dsPackQty = _dsPackQ && parseInt(_dsPackQ.value, 10) > 0 ? parseInt(_dsPackQ.value, 10) : 1;
    var mainItem = { id: currentVariantId, quantity: _dsPackQty };
    if (window.__dsSellingPlan && window.__dsSellingPlan.id) {
      mainItem.selling_plan = window.__dsSellingPlan.id;
    }
    var cartItems = [mainItem];

    // Cross-Sell-Toggle (wenn aktiv): zweites Item dazu
    // FIX 2026-05-20: data-current-variant-id reflektiert aktuelle User-Selection;
    // initialVariantId war Page-Load-Default und ignorierte Variant-Wechsel → Bug "schwarzes Geschirr + rote Leine"
    var csToggle = document.querySelector('[data-ds-cs-toggle]');
    var csRoot = document.querySelector('[data-ds-cross-sell]');
    var csConfigEl = document.querySelector('[data-ds-cross-sell-config]');
    if (csToggle && csConfigEl && csToggle.getAttribute('aria-checked') === 'true') {
      try {
        var csConfig = JSON.parse(csConfigEl.textContent);
        var csVariantId = null;
        if (csRoot && csRoot.getAttribute('data-current-variant-id')) {
          csVariantId = parseInt(csRoot.getAttribute('data-current-variant-id'), 10);
        }
        if (!csVariantId && csConfig && csConfig.initialVariantId) {
          csVariantId = csConfig.initialVariantId;
        }
        if (csVariantId) {
          cartItems.push({ id: csVariantId, quantity: 1, properties: { '_upsell': '1' } });
        }
      } catch (ex) { /* silent */ }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add failed: ' + r.status);
      return r.json();
    })
    .then(function() {
      // Apple-iOS Light systemGreen #34C759 via CSS-Klasse (animated check + "Gute Wahl!")
      btn.classList.add('ds-cart-bar__btn--success');
      textEl.textContent = labelAdded;
      // CustomEvent triggert Cart-Drawer-Open + Cross-Sell-Reminder + Header-Cart-Count
      // ds-cart-tracking.js Interceptor hat den Fetch bereits erfasst → GA4 add_to_cart auto
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      setTimeout(function() {
        btn.classList.remove('ds-cart-bar__btn--success');
        textEl.textContent = origText;
        btn.disabled = false;
        isAdding = false;
      }, 2200);
    })
    .catch(function(err) {
      console.error('Sticky Cart Bar: Add failed', err);
      textEl.textContent = origText;
      btn.disabled = false;
      isAdding = false;
    });
  });

  /* ─── Variant-Sync: Preis + Verfuegbarkeit ─── */
  var variantSelect = document.getElementById('ProductSelect-' + sectionId);
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (!opt) return;
      currentVariantId = parseInt(opt.value, 10) || currentVariantId;
      btn.disabled = opt.disabled;
      textEl.textContent = opt.disabled ? labelSoldout : labelAdd;
    });
  }

  /* Image-Element fuer Variant-Sync (v24 Layout-Upgrade) */
  var imgEl = document.getElementById('DsCartBarImg');

  function dsUpdateStickyImage(variant) {
    if (!imgEl || !variant) return;
    var srcCandidate = null;
    if (variant.featured_image && variant.featured_image.src) {
      srcCandidate = variant.featured_image.src;
    } else if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      srcCandidate = variant.featured_media.preview_image.src;
    }
    if (!srcCandidate) return;
    /* Shopify CDN: append width-param so wir kein 5MB-Image laden */
    var sep = srcCandidate.indexOf('?') === -1 ? '?' : '&';
    if (!/[?&]width=/.test(srcCandidate)) srcCandidate = srcCandidate + sep + 'width=240';
    if (imgEl.getAttribute('src') !== srcCandidate) imgEl.setAttribute('src', srcCandidate);
  }

  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) {
      var v = e.detail.variant;
      currentVariantId = v.id;
      if (priceEl && v.price != null) priceEl.textContent = dsFormatMoney(v.price);
      btn.disabled = !v.available;
      textEl.textContent = v.available ? labelAdd : labelSoldout;
      dsUpdateStickyImage(v);
    }
  });

  var sectionContainer = document.querySelector('[data-section-id="' + sectionId + '"]');
  if (sectionContainer) {
    sectionContainer.addEventListener('variantPriceChange', function(e) {
      if (e.detail && e.detail.variant) {
        var v = e.detail.variant;
        currentVariantId = v.id;
        if (priceEl && v.price != null) priceEl.textContent = dsFormatMoney(v.price);
        dsUpdateStickyImage(v);
      }
    });
  }

  log('initialized', {
    sectionId: sectionId,
    initialVariant: currentVariantId,
    available: !btn.disabled
  });

  /* ════════════════════════════════════════════════════════════════════════
   * Variant-Image Auto-Scroll (v23 inline, statt separater Datei)
   * Bei JEDEM variant:change oder Color-Swatch-Klick auf Mobile/Tablet:
   * scroll smooth zum Hauptbild sodass Bild im oberen 25% des Viewports landet.
   * ════════════════════════════════════════════════════════════════════════ */
  (function variantImageScroll() {
    // Desktop ueberspringen
    if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) return;

    function findImageWrap() {
      return document.querySelector('.product__main-photos') ||
             document.querySelector('[data-product-single-media-group]') ||
             document.querySelector('[data-product-photos]');
    }

    function getHeaderHeight() {
      var hdr = document.querySelector('.site-header') ||
                document.querySelector('header') ||
                document.querySelector('.sn-header');
      return (hdr && hdr.offsetHeight) || 56;
    }

    function scrollToImage(variant) {
      var imgWrap = findImageWrap();
      if (!imgWrap) { log('VariantScroll: imgWrap not found'); return; }

      var headerH = getHeaderHeight();
      var rect = imgWrap.getBoundingClientRect();
      var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var imgPageTop = rect.top + pageY;
      var imgHeight = imgWrap.offsetHeight || rect.height || 375;
      var vh = window.innerHeight;
      var spaceAbove;
      if (imgHeight + headerH + 32 >= vh) {
        spaceAbove = headerH + 8;
      } else {
        spaceAbove = headerH + Math.max(8, (vh - headerH - imgHeight) * 0.25);
      }
      var targetY = Math.max(0, imgPageTop - spaceAbove);

      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      log('VariantScroll: targetY=' + targetY + ' currentY=' + currentY + ' reducedMotion=' + reducedMotion);

      if (reducedMotion || Math.abs(targetY - currentY) < 4) {
        var se = document.scrollingElement || document.documentElement;
        se.scrollTop = targetY;
        document.documentElement.scrollTop = targetY;
        document.body.scrollTop = targetY;
        return;
      }

      // Image-Flash-Animation als visueller Polish (CSS .ds-variant-flash).
      // Macht das Scroll-Snap visuell weicher: User-Aufmerksamkeit auf Image-Pop, nicht auf Scroll.
      var imgWrapFlash = findImageWrap();
      if (imgWrapFlash) {
        imgWrapFlash.classList.remove('ds-variant-flash');
        requestAnimationFrame(function() {
          imgWrapFlash.classList.add('ds-variant-flash');
        });
        setTimeout(function() {
          imgWrapFlash.classList.remove('ds-variant-flash');
        }, 700);
      }

      // Smooth-Scroll Strategie:
      // 1) CSS scroll-behavior:smooth setzen → folgende scrollTop-Writes werden smooth animiert
      // 2) Sync direct-write auf scrollingElement (Browser respektiert behavior bei smooth-css)
      // 3) Multiple writes (belt-and-suspenders fuer cross-browser)
      // 4) Reset scroll-behavior nach 1s
      var html = document.documentElement;
      var prevBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'smooth';

      var se = document.scrollingElement || document.documentElement;
      se.scrollTop = targetY;
      document.documentElement.scrollTop = targetY;
      document.body.scrollTop = targetY;
      try { window.scroll(0, targetY); } catch (e) {}

      log('VariantScroll: smooth-scroll via CSS scroll-behavior triggered, currentY=' + (window.pageYOffset||0));

      // Reset scroll-behavior nach Animation
      setTimeout(function() {
        html.style.scrollBehavior = prevBehavior || '';
      }, 1000);

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'ds_variant_image_revealed',
          variant_id: variant ? variant.id : null,
          method: 'auto_scroll'
        });
      }
    }

    // Trigger-Strategie (Root-Cause-fix):
    // Das eigentliche Problem ist NICHT Theme.js, sondern Browser-Focus-Scroll
    // (Browser scrollt Radio-Input ins View beim Click → scrollY = swatch-position).
    // Loesung: ~700ms warten (Browser-Focus-Scroll ist fertig), dann CLEAN smooth-scroll.
    // Plus: focus-scroll preventieren via mousedown-Listener mit pre-scroll Lock.
    var scrollDelay = 720;
    var scrollPending = null;

    // Preventionsmechanismus fuer Browser-Focus-Scroll auf Radio-Inputs:
    // Wenn User auf Swatch klickt, merken wir uns scrollY VOR dem Click.
    // Nach Focus-Scroll restore (per RAF) wir die scroll-Position.
    // → Browser-Scroll wird neutralisiert, unsere smooth-scroll-Animation laeuft ohne Race.
    var preClickScrollY = null;
    function isColorSwatch(el) {
      return el && (
        el.matches && (el.matches('[data-color-swatch]') ||
                       el.matches('.color-swatch') ||
                       el.matches('label[for*="swatch" i]') ||
                       el.matches('input[type="radio"][data-variant-input]'))
      );
    }
    document.addEventListener('mousedown', function(e) {
      var swatch = e.target.closest && e.target.closest('[data-color-swatch], .color-swatch, label[for*="swatch" i]');
      if (!swatch) return;
      preClickScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    }, { capture: true, passive: true });
    document.addEventListener('touchstart', function(e) {
      var swatch = e.target.closest && e.target.closest('[data-color-swatch], .color-swatch, label[for*="swatch" i]');
      if (!swatch) return;
      preClickScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    }, { capture: true, passive: true });
    // Nach Focus-Event: scroll-Position restoren (Browser-Focus-Scroll neutralisieren)
    document.addEventListener('focusin', function(e) {
      if (preClickScrollY === null) return;
      if (!e.target.matches || !e.target.matches('input[type="radio"]')) return;
      var lock = preClickScrollY;
      preClickScrollY = null;
      // RAF nach Browser-Focus-Scroll-Render: restore
      requestAnimationFrame(function() {
        var se = document.scrollingElement || document.documentElement;
        se.scrollTop = lock;
        document.documentElement.scrollTop = lock;
        document.body.scrollTop = lock;
      });
    }, { capture: true });

    function queueScroll(variant) {
      if (scrollPending) clearTimeout(scrollPending);
      scrollPending = setTimeout(function() {
        scrollPending = null;
        scrollToImage(variant);
      }, scrollDelay);
    }

    // Track previous option1 (= Color in DS-Setup) → nur scrollen wenn Color-Wechsel,
    // nicht bei Size-Wechsel (option2).
    var prevOption1 = null;
    document.addEventListener('variant:change', function(e) {
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      // Erster Aufruf: prevOption1 setzen, nicht scrollen (initial load)
      if (prevOption1 === null) {
        prevOption1 = v.option1;
        return;
      }
      // Wenn option1 (Color) gleich → war Size-Aenderung → KEIN scroll
      if (v.option1 === prevOption1) {
        log('VariantScroll: size-only change (option1 unchanged), skip scroll');
        return;
      }
      prevOption1 = v.option1;
      log('VariantScroll: color change detected, queue scroll in ' + scrollDelay + 'ms');
      queueScroll(v);
    });

    document.addEventListener('ds:variantImageChanged', function(e) {
      if (e.detail && e.detail.variant) {
        queueScroll(e.detail.variant);
      }
    });

    // Click-Trigger als Backup (variant:change feuert nicht immer)
    document.addEventListener('click', function(e) {
      var swatch = e.target.closest('[data-color-swatch], .color-swatch, label[for*="swatch"], input[type="radio"][data-variant-input]');
      if (!swatch) return;
      var name = (swatch.name || swatch.getAttribute('name') || '').toLowerCase();
      var dataIndex = (swatch.getAttribute('data-index') || '').toLowerCase();
      var label = swatch.tagName === 'LABEL' && swatch.htmlFor ? document.getElementById(swatch.htmlFor) : null;
      var labelName = label ? (label.name || '').toLowerCase() : '';
      var isColor = name.includes('farbe') || name.includes('color') ||
                    labelName.includes('farbe') || labelName.includes('color') ||
                    swatch.matches('[data-color-swatch]') || swatch.matches('.color-swatch') ||
                    dataIndex === 'option1';
      if (!isColor) return;
      log('VariantScroll: color-swatch click, queue scroll in ' + scrollDelay + 'ms');
      queueScroll(null);
    });

    log('VariantScroll: initialized (mobile/tablet)');
  })();

  /* ─── Cart-Drawer-Sync: Hide Sticky-Bar wenn Drawer offen (Bug-Fix 2026-05-20) ─── */
  /* CSS macht visuelle Hide via !important. JS synct State-Attrs + a11y. */
  (function drawerSyncHide() {
    function isDrawerOpen() {
      return document.body.classList.contains('sn-cart-open') ||
             document.documentElement.classList.contains('js-drawer-open') ||
             document.body.classList.contains('js-drawer-open');
    }
    function applyHidden() {
      bar.setAttribute('data-state', 'hidden');
      bar.setAttribute('aria-hidden', 'true');
    }
    function reEval() {
      if (isDrawerOpen()) {
        applyHidden();
        log('drawer-open -> bar hidden (state+aria sync)');
      } else {
        log('drawer-close -> bar visibility re-eval via scroll-event');
        window.dispatchEvent(new Event('scroll'));
      }
    }
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'class') { reEval(); return; }
        }
      });
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      log('drawer-sync observer attached');
    }
    // ajaxProduct:added Event: Sticky-Bar sofort hiden (Drawer wird gleich danach geoeffnet)
    document.addEventListener('ajaxProduct:added', function() {
      applyHidden();
      log('ajaxProduct:added -> bar hidden');
    });
  })();

})();
